// extracted by mini-css-extract-plugin
export default {"cardsContainer":"MatchGrid_cardsContainer__5NQtP"};